export const en = {
  CANONICAL_LOCALE: "en-US",

  "general.send": "Send",
  "general.cancel": "Cancel",
  "general.apply": "Apply",
  "general.name": "Name",
  "general.privacy": "Privacy",
  "general.recipients": "Recipients",
  "general.message": "Message",
  "general.toFilter": "Filter",
  "general.messageSingular": "message",
  "general.messagePlural": "messages",
  "general.messageSettings": "Message settings",

  "date.shortYear": "year",
  "date.shortYears": "years",
  "date.shortMonth": "month",
  "date.shortMonths": "months",
  "date.shortDay": "day",
  "date.shortDays": "days",
  "date.shortHour": "h",
  "date.shortMinute": "m",
  "date.now": "now",
  "date.today": "Today",
  "date.yesterday": "Yesterday",
  "date.start": "Start",
  "date.end": "End",

  "filter.filterByPeriod": "Filter by period",
  "filter.filterByProcess": "Filter by process",
  "filter.filterByRecipient": "Filter by participant",
  "filter.clearFilters": "Clear filters",
  "filter.filterByFlag": "Filter by flag",
  "filter.searchIn": "Search in {name}",
  "filter.numberOfactiveMessages": "{number} {sufix}",
  "filter.noMessages": "No",
  "filter.allActiveMessages": "All active messages",
  "filter.allActiveMessages.sufixForLabels": "active messages",
  "filter.allActiveMessages.sufixForLabels.singular": "active message",
  "filter.archivedMessages": "Archived only",
  "filter.archivedMessages.sufixForLabels": "archived messages",
  "filter.archivedMessages.sufixForLabels.singular": "archived message",
  "filter.allMessages": "All messages",
  "filter.allMessages.sufixForLabels": "messages",
  "filter.allMessages.sufixForLabels.singular": "message",
  "filter.messagesOpenedByMe": "Opened by me",
  "filter.messagesOpenedByMe.sufixForLabels": "opened by me",
  "filter.messagesOpenedByMe.sufixForLabels.singular": "opened by me",
  "filter.allFinilizedTasks": "Finalized tasks only",
  "filter.allFinilizedTasks.sufixForLabels": "finalized tasks",
  "filter.allFinilizedTasks.sufixForLabels.singular": "finalized task",

  "chat.messages": "Messages",
  "chat.settings": "Settings",
  "chat.chatSettings": "Chat settings",
  "chat.userNotFound": "User not found",
  "chat.typeUserName": "Type username to start searching",
  "chat.typeMessage": "Type message...",
  "chat.mentionUser": "Mention user",
  "chat.sendTo": "Send to...",
  "chat.optionalTitle": "Title (opcional)",
  "chat.archiveMessage": "Archive message",
  "chat.newMessage": "New messagem",
  "chat.newChat": "New chat",
  "chat.noDescriptionTitle": "{archived} {name} and {number} other",
  "chat.noDescriptionTitleNoOthers": "{archived} {name}",
  "chat.archivedPrefix": "(archived)",
  "chat.optional": "(optional) ",
  "chat.noOptionsAvailable": "Options are not available",
  "chat.newMessagesReceived": "You received {number} {messagePlural}",
  "chat.noFlag": "Untagged",
  "chat.flag": "Tag",
  "chat.task": "Task",
  "chat.flagFinalize": 'Finalize "{flag}"',
  "chat.finalizedPrefix": "(finalized)",
  "chat.disabledUser": "disabled",
  "chat.someUsersInactive":
    "Some users are inactive and will not receive messages",
  "chat.allUsersInactive":
    "All users are inactive and will not receive messages",
  "chat.fetchActiveUsersError": "An error occurred while fetching active users",

  "chat.fileSizeExceeded": "The file exceeds the supported size of {maxSize}.",
  "chat.fileTypeError": "Unsupported file type.",
  "chat.fileEmptyError": "Empty file. Please select a valid one.",
  "chat.attachmentError": "Error sending the file. Please try again.",
  "chat.attachFile": "Attach file",
  "chat.viewFile": "View file",
  "chat.viewError": "Error viewing the file. Please try again.",
  "chat.downloadFile": "Download file",
  "chat.downloadError": "Error downloading the file. Please try again.",

  "chat.newChatFileDisabled":
    "You will only be able to send files after starting the conversation.",
  "chat.cycle": "Cycle {number}",
  "chat.chatEvents.OPEN_FLOW": "Open flow",
  "chat.chatEvents.OPEN_FORM": "Open form",
  "message.empty": "Communicate with your team!",
  "message.empty.description":
    "Write messages to ask questions to someone or with other participants",
  "message.error": "An error has occurred",
  "message.error.description":
    "Content could not be loaded. Check your connection, refresh the page, or try again in a moment.",
  "message.noResults": "No results were found",
  "message.noResults.description":
    "Change your filters or write a new message.",

  "privacy.public": "Public",
  "privacy.public.description":
    "Sent to selected recipients and can be accessed by any other user who has permission to access the process.",
  "privacy.participants": "Participants",
  "privacy.participants.description":
    "Sent to selected recipients and can be accessed by any other user who has participated in the process as responsible for activities that are being carried out or already approved.",
  "privacy.private": "Private",
  "privacy.private.description": "Sent only to selected recipients.",

  "settings.inbox": "Inbox",
  "settings.sendMessage": "Message",
  "settings.notifications": "Notification",
  "settings.dynamicMessage": "Dynamic message filter",
  "settings.dynamicMessage.description":
    "Whenever you navigate or click on a process or activity, the messages linked to them will be automatically filtered. Filters will still be applied normally",
  "settings.alwaysOpenNewMessages": "Always open new messages",
  "settings.alwaysOpenNewMessages.description":
    "When you receive new messages, their chat will automatically open in a new window.",
  "settings.pressEnterToSendMessage": "Press Enter to send message",
  "settings.pressEnterToSendMessage.description":
    "Sending messages will be available by pressing Enter.",
  "settings.receiveEmailNotifications": "Receive e-mail notifications",
  "settings.receiveEmailNotifications.description":
    "Start to receive e-mail notifications.",
  "settings.receiveMentionEmailNotifications":
    "Receive mention e-mail notifications",
  "settings.receiveMentionEmailNotifications.description":
    "Receive an e-mail whenever you are mentioned with @ in a message.",
  "settings.more": "More settings",
  "settings.notifications.description":
    "Choose between receiving all notifications or only mentions with @",

  "error.reconnectingIn": "Reconnecting in {seconds} second(s)",
  "error.reconnecting": "Reconnecting...",
  "error.connectionLost": "Connection lost",

  "tooltip.close": "Close",
  "tooltip.newChat": "New chat",
  "tooltip.moreActions": "Settings",
  "tooltip.moreOptions": "More actions",
  "tooltip.searchFilters": "Filter",
  "tooltip.clearFilters": "Clear filters",

  "profiles.manager": "Manager",
  "profiles.last-approver": "Last_Approver",
};
